// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const ChevronLeftDoubleIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon
      data-iconname="ChevronLeftDoubleIcon"
      ref={forwardedRef}
      {...props}
    >
      <path d="M9.364 3.636 3 10l6.364 6.364 1.057-1.057L5.121 10l5.304-5.303z" />
      <path d="M14.364 3.636 8 10l6.364 6.364 1.057-1.057-5.3-5.307 5.304-5.303z" />
    </SvgIcon>
  );
});

/**
 * Use to expand or collapse elements. Use CloseSidebarIcon or OpenSidebarIcon for sidebar
 * @public
 */
export const ChevronLeftDoubleIcon = /* @__PURE__ */ Object.assign(
  ChevronLeftDoubleIconComponent,
  { displayName: 'ChevronLeftDoubleIcon' },
);
